import { Collapse } from '../../views/ts/components/Collapse';
import { PageLogin } from '../twig/pages/login';
import { ModeratorDashboard } from '../twig/pages/moderator';
import { Tabs } from '../../views/ts/components/Tabs';
import { SingleTutorial } from '../twig/pages/single-tutorial';
import { Toast } from '../twig/components/Toast';
import { Dashboard } from '../twig/pages/dashboard';
import { Forms } from './components/Forms';
import { Menu } from '../twig/components/Menu';
import { Header } from '../twig/components/Header';
import { Footer } from '../twig/components/Footer';
import { Directory } from '../twig/modules/directory';
import { Print } from './components/Print';
/*(new Analytics()).init();
(new Carousel()).init();*/
(new Collapse()).init();
(new Tabs()).init();
/*(new Dropdown()).init();
(new LazyLoader()).init();
(new ScrollSpy()).init();*/
(new PageLogin()).init();
(new ModeratorDashboard()).init();
(new SingleTutorial()).init();
(new Toast()).init();
(new Dashboard()).init();
(new Forms()).init();
(new Menu()).init();
(new Header()).init();
(new Footer()).init();
(new Directory()).init();
(new Print()).init();
